import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getPlanPrioritizationProductionSites({ commit }) {
        commit('GET_PLAN_PRIORITIZATION_PRODUCTION_SITES_REQUEST')

        return axios
            .get('/schedule-prioritization/production-sites')
            .then(response => {
                commit('GET_PLAN_PRIORITIZATION_PRODUCTION_SITES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_PLAN_PRIORITIZATION_PRODUCTION_SITES_FAILURE')
                handleApiError(error, 'Pobranie stanowisk do priorytetyzacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getScheduledTasks(context, payload) {
        const { machineCode, limit, sortByPriority, productionSiteId } = payload

        if (!productionSiteId) {
            return Promise.reject(new Error('productionSiteId jest wymagane'))
        }

        const searchParams = new URLSearchParams()

        if (machineCode) {
            searchParams.append('machCode', machineCode)
        }
        if (limit) {
            searchParams.append('limit', limit)
        }
        if (sortByPriority !== undefined) {
            searchParams.append('sortByPriority', sortByPriority)
        }

        const queryString = searchParams.toString()
        const url = `/schedule-prioritization/scheduled-tasks/${productionSiteId}${queryString ? `?${queryString}` : ''}`

        return axios
            .get(url)
            .then(response => Promise.resolve(response))
            .catch(error => {
                handleApiError(error, 'Pobranie zaplanowanych zadań nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateTasksPriority(context, payload) {
        return axios
            .post('/schedule-prioritization/prioritized-tasks', payload)
            .then(response => Promise.resolve(response))
            .catch(error => {
                handleApiError(error, 'Aktualizacja priorytetów nie powiodła się.')

                return Promise.reject(error)
            })
    }
}
